import WideskNavigation        from '@widesk-ui/components/Navigation';
import navigation              from '@/navigation';
import { NAVIGATION_ACCESS }   from '@/navigation';
import useTheme                from '@widesk-ui/hooks/useTheme';
import View                    from '@widesk-ui/components/View';
import Link                    from '@widesk-ui/components/Link';
import { BuildOutlined }       from '@ant-design/icons';
import { EnvironmentOutlined } from '@ant-design/icons';
import { LayoutOutlined }      from '@ant-design/icons';
import { PushpinOutlined }     from '@ant-design/icons';
import { useLocation }         from 'react-router-dom';
import { useParams }           from 'react-router-dom';
import { observer }            from 'mobx-react';
import useAccount              from '@/hooks/useAccount';
import accessStore             from '@/stores/accessStore';

const LayoutSider = observer(function LayoutSider() {
	const theme = useTheme();
	const { account } = useAccount();

	const { id, projectId: pid } = useParams();
	const location = useLocation();

	let projectId = pid;
	if (id && !pid && location.pathname.startsWith('/projects/')) {
		projectId = id;
	}

	const items = navigation.filter(item => {
		const access = NAVIGATION_ACCESS[item.link];

		return !access || accessStore.can(access);
	});

	return (
		<>
			<View className="sider-top" flex style={{ overflow: 'auto' }}>
				<View center paddingT={theme.marginMD} paddingB={theme.marginXS * 1.8}>
					<Link to="/">
						<img
							className="app-logo"
							style={{ width: '195px', height: '30px', maxWidth: '80%', display: 'block', margin: 'auto' }}
							src="/logo-white.svg"
							alt=""
						/>
					</Link>
				</View>

				{account && (
					<View className="sider-anim" flex style={{ overflow: 'auto' }}>
						<WideskNavigation items={items} />
						{projectId && (
							<WideskNavigation items={[
								{ label: 'Aperçu général', icon: <LayoutOutlined />, link: `/projects/${projectId}` },
								{ label: 'Cartes', icon: <EnvironmentOutlined />, link: `/projects/${projectId}/maps/split` },
								{ label: 'Places', icon: <PushpinOutlined />, link: `/projects/${projectId}/places/split` },
								{ label: 'Types de places', icon: <BuildOutlined />, link: `/projects/${projectId}/place_types/split` },
							]} />
						)}
					</View>
				)}
			</View>
		</>
	);
});

export default LayoutSider;
